import { MultipleVerticalsTypes, ServiceType } from '@/__generated__/globalTypes';

const useMultiVerticalServiceTypes = () => {
  const mapVerticalToServiceType = (verticalType: MultipleVerticalsTypes): ServiceType => {
    switch (verticalType) {
      case MultipleVerticalsTypes.CHILDCARE:
        return ServiceType.CHILD_CARE;
      case MultipleVerticalsTypes.HOUSEKEEP:
        return ServiceType.HOUSEKEEPING;
      case MultipleVerticalsTypes.PETCAREXX:
        return ServiceType.PET_CARE;
      case MultipleVerticalsTypes.SENIRCARE:
        return ServiceType.SENIOR_CARE;
      case MultipleVerticalsTypes.TUTORINGX:
        return ServiceType.TUTORING;
      default:
        return ServiceType.CHILD_CARE; // Default mapping
    }
  };

  return mapVerticalToServiceType;
};
export default useMultiVerticalServiceTypes;
